/**
 * "N documents need your action" — the nudge toward pending signatures and
 * agreement votes.
 *
 * Its CTA turns on the Action-required facet rather than navigating anywhere,
 * so the banner and the facet pill are two doors to the same filtered listing.
 * Amber is shared with that pill deliberately: same colour, same meaning.
 */

import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export function ActionRequiredBanner({ count, onShowOnly }) {
  const { t } = useTranslation(['mainPage']);

  return (
    <div className="mb-4 flex items-center justify-between rounded-[4px] border border-amber-200 bg-amber-50 dark:bg-amber-900/20 dark:border-amber-800 px-4 py-3">
      <div className="flex items-center gap-2 text-sm text-amber-800 dark:text-amber-200">
        <AlertTriangle className="h-4 w-4" />
        <span>{t('mainPage:actionBanner.text', { count })}</span>
      </div>
      <Button
        size="sm"
        variant="ghost"
        className="text-amber-800 hover:text-amber-900 dark:text-amber-200"
        onClick={onShowOnly}
      >
        {t('mainPage:actionBanner.cta')} →
      </Button>
    </div>
  );
}
